import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoPowerspaceSpinner = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 60 60",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff008e",
			d: "   M 48.31 0.00   L 49.56 0.00   Q 51.25 1.23 51.25 2.50   C 51.22 16.56 54.33 32.96 36.53 37.07   Q 35.64 37.28 36.12 36.50   C 42.80 25.82 38.07 13.48 26.59 9.54   A 0.32 0.32 0.0 0 1 26.71 8.92   C 31.10 9.20 39.17 9.71 42.76 6.67   C 44.92 4.84 45.51 1.92 48.31 0.00   Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffde00",
			d: "   M 0.00 11.94   L 0.00 10.94   Q 0.85 9.02 2.50 9.01   C 16.47 8.97 33.00 5.92 37.21 24.02   A 0.25 0.25 0.0 0 1 36.82 24.28   C 26.69 17.34 13.85 21.97 9.69 33.28   A 0.36 0.35 -35.0 0 1 9.00 33.16   C 9.00 25.78 10.45 18.09 2.33 14.33   C 1.17 13.80 0.52 12.99 0.00 11.94   Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#7cc90c",
			d: "   M 11.94 60.00   L 11.19 60.00   C 10.00 59.70 9.43 59.08 9.33 57.81   C 8.74 50.64 7.73 37.85 11.59 31.57   Q 15.38 25.39 23.17 23.08   A 0.61 0.61 0.0 0 1 23.85 24.01   C 17.17 34.03 22.47 46.61 33.45 50.60   A 0.35 0.35 0.0 0 1 33.32 51.28   C 28.70 51.16 21.30 50.31 17.54 53.34   C 15.31 55.13 14.75 58.08 11.94 60.00   Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#009ee2",
			d: "   M 57.45 51.16   C 44.23 51.83 29.15 53.83 23.27 37.73   Q 22.12 34.58 24.85 36.54   C 34.45 43.44 47.39 36.59 50.68 26.20   Q 51.10 24.87 51.18 26.26   C 51.49 31.88 49.89 38.99 54.54 43.60   C 56.27 45.31 60.32 45.88 60.07 48.99   Q 59.91 51.04 57.45 51.16   Z"
		})
	]
});
export default SvgLogoPowerspaceSpinner;
